import Swal from 'sweetalert2';
import api from './Api';
import { IRazaoLayoutConfig } from '../interfaces/IRazaoLayoutConfig';

class RazaoLayoutConfigService {
  async getAll(): Promise<IRazaoLayoutConfig[]> {
    try {
      const { data } = await api.get<IRazaoLayoutConfig[]>('razaolayoutconfig');
      return data;
    } catch (error: any) {
      Swal.fire({ text: error.response?.data?.message ?? error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return [];
    }
  }

  async getById(id: number): Promise<IRazaoLayoutConfig | null> {
    try {
      const { data } = await api.get<IRazaoLayoutConfig>(`razaolayoutconfig/${id}`);
      return data;
    } catch (error: any) {
      Swal.fire({ text: error.response?.data?.message ?? error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return null;
    }
  }

  async create(payload: Omit<IRazaoLayoutConfig, 'id' | 'dataCadastro' | 'dataAtualizacao'>): Promise<IRazaoLayoutConfig | null> {
    try {
      const { data } = await api.post<IRazaoLayoutConfig>('razaolayoutconfig', payload);
      return data;
    } catch (error: any) {
      Swal.fire({ text: error.response?.data?.message ?? error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return null;
    }
  }

  async update(id: number, payload: Omit<IRazaoLayoutConfig, 'dataCadastro' | 'dataAtualizacao'>): Promise<boolean> {
    try {
      await api.put(`razaolayoutconfig/${id}`, payload);
      return true;
    } catch (error: any) {
      Swal.fire({ text: error.response?.data?.message ?? error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return false;
    }
  }

  async delete(id: number): Promise<boolean> {
    try {
      await api.delete(`razaolayoutconfig/${id}`);
      return true;
    } catch (error: any) {
      Swal.fire({ text: error.response?.data?.message ?? error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return false;
    }
  }
}

const razaoLayoutConfigService = new RazaoLayoutConfigService();
export default razaoLayoutConfigService;
